import React, { ReactElement } from 'react';
import { Tooltip } from '@mui/material';

import { useI18n } from '../hooks/useI18n';
import { useTranslationContext } from '../context/TranslationContext';
import { TranslationKeys } from '../i18n/locales/defaultResources';

interface TooltipTranslationHelperProps {
  titleKey: TranslationKeys;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  children: ReactElement;
}

const TooltipTranslationHelper: React.FC<TooltipTranslationHelperProps> = ({
  titleKey,
  placement = 'top',
  children,
}) => {
  const { t } = useI18n();
  const { isTranslationMode } = useTranslationContext();

  return (
    <Tooltip
      title={t(titleKey)}
      placement={placement}
      open={isTranslationMode ? true : undefined}
    >
      {children}
    </Tooltip>
  );
};

export default TooltipTranslationHelper;
